import { Empty, Pagination } from 'antd';
import BannerWithImage from 'components/BannerWithImage';
import CalendarAsc from 'components/Icons/CalendarAsc';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import CalendarDesc from 'components/Icons/CalendarDesc';
import { I18nt } from 'utils';
import styles from './ExamenesLab.module.less';

import ExamenBox from '../components/ExamenCard';
import { useExamenesLabCtx } from '../ExamenesLabContext';
import { useMemo } from 'react';

const ResultsView = () => {
  const {
    consultaExamenes: examenes,
    nombrePaciente,
    sort,
    dispatch,
    perPage,
    page,
    setPage,
  } = useExamenesLabCtx();

  const handlePageClick = (page: number) => {
    setPage(page - 1);
  };

  const paginatedExamenes = () => {
    const startElement = page * perPage;
    const endElement = startElement + perPage;
    return examenes.slice(startElement, endElement);
  };

  const previasCitasMap = useMemo(() => {
    if (examenes.length === 0) {
      return (
        <div className={styles.emptyProximasCitas}>
          <Empty description={I18nt('no_tienes_citas_historial')} />;
        </div>
      );
    }

    return (
      <>
        {paginatedExamenes().map((examen) => (
          <ExamenBox examen={examen} key={examen.id} />
        ))}
        <Pagination
          className={styles.pagination}
          total={examenes.length}
          pageSize={perPage}
          current={page + 1}
          onChange={handlePageClick}
        />
      </>
    );
  }, [examenes, page, sort]);

  const handleSortClick = () => {
    const sortDirection = sort === 'desc' ? 'asc' : 'desc';
    dispatch({
      type: 'sortExamenesCitas',
      payload: sortDirection,
    });
  };

  return (
    <BannerWithImage className={styles.resultsView}>
      <div className={styles.resultsWrapper}>
        <div className={styles.header}>
          <div className={styles.headerText}>
            <h4>{I18nt('examenes_de_laboratorio')}</h4>
            <p>{I18nt('aqui_consultar_resultados')}</p>
            <div className={styles.reminderBox}>
              <ExclamationCircleOutlined />
              <p>{I18nt('recuerda_que_hay_examenes')}</p>
            </div>
            <p className={styles.paciente}>
              <span>{`${I18nt('paciente')}: `}</span>
              {nombrePaciente}
            </p>
          </div>
          <div className={styles.headerActions}>
            <div
              className={styles.actionButton}
              onClick={handleSortClick}
            >
              {sort === 'desc' ? <CalendarAsc /> : <CalendarDesc />}
              <p>{I18nt('ordenar')}</p>
            </div>
          </div>
        </div>
        <div className={styles.citasList}>
          <h4 className={styles.titleExamenes}>{I18nt('examenes')}</h4>
          {previasCitasMap}
        </div>
      </div>
    </BannerWithImage>
  );
};

export default ResultsView;
